import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-invalid-login',
    templateUrl: './invalid-login.component.html',
    styleUrls: ['../../login.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InvalidLoginComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
